import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {QBUserMapping, TimeSheetImportCell} from "@app/shared/classes/quickbooks/qbuser-mapping";
import {InvoiceImportCCMapping, InvoiceImportDefaultSetting, InvoiceImportItem, InvoiceImportItemMapping, InvoiceImportVendorMapping} from "@app/shared/classes/dataimport/invoice-import-item";

@Injectable({
  providedIn: 'root'
})
export class ImportDataService {

  constructor(private http: HttpClient) { }

  getImportCells(): Observable<InvoiceImportItem[]> {
    const url = '/data-import/vendor-invoice/import-cells';
    return this.http.get<InvoiceImportItem[]>(url);
  }

  saveImportCells(importItems: InvoiceImportItem[]): Observable<InvoiceImportItem[]> {
    const url = '/data-import/vendor-invoice/import-cells';
    return this.http.put<InvoiceImportItem[]>(url, importItems);
  }

  importVendorInvoices(startDate: string, endDate: string, vendor?: string): Observable<any> {
    let url = `/data-import/vendor-invoice/import-cells/import-vendor-invoices?startDate=${startDate}&endDate=${endDate}`;
    if(vendor){
      url = url+ `&vendor=${vendor}`;
    }
    return this.http.post<any>(url, {});
  }

  getDefaultVendorInvoiceImportConfiguration():Observable<InvoiceImportDefaultSetting>{
    const url = '/data-import/vendor-invoice/default-configuration';
    return this.http.get<InvoiceImportDefaultSetting>(url);
  }
  saveDefaultVendorInvoiceImportConfiguration(mappings: InvoiceImportDefaultSetting): Observable<InvoiceImportDefaultSetting> {
    const url = '/data-import/vendor-invoice/default-configuration';
    return this.http.put<InvoiceImportDefaultSetting>(url, mappings);
  }

  refreshDefaultVendorInvoiceImportConfiguration():Observable<InvoiceImportDefaultSetting>{
    const url = '/data-import/vendor-invoice/default-configuration/refresh';
    return this.http.post<InvoiceImportDefaultSetting>(url, {});
  }


  getVendorMappings():Observable<InvoiceImportVendorMapping[]>{
    const url = '/data-import/vendor-invoice/vendor-mappings';
    return this.http.get<InvoiceImportVendorMapping[]>(url);
  }
  saveVendorMappings(mappings: InvoiceImportVendorMapping[]): Observable<InvoiceImportVendorMapping[]> {
    const url = '/data-import/vendor-invoice/vendor-mappings';
    return this.http.put<InvoiceImportVendorMapping[]>(url, mappings);
  }

  importVendorMappings():Observable<InvoiceImportVendorMapping[]>{
    const url = '/data-import/vendor-invoice/vendor-mappings-import';
    return this.http.post<InvoiceImportVendorMapping[]>(url, {});
  }


  getInvoiceChargeCodeMappings():Observable<InvoiceImportCCMapping[]>{
    const url = '/data-import/vendor-invoice/cc-mappings';
    return this.http.get<InvoiceImportCCMapping[]>(url);
  }
  saveInvoiceChargeCodeMappings(mappings: InvoiceImportCCMapping[]): Observable<InvoiceImportCCMapping[]> {
    const url = '/data-import/vendor-invoice/cc-mappings';
    return this.http.put<InvoiceImportCCMapping[]>(url, mappings);
  }

  importInvoiceChargeCodeMappings():Observable<InvoiceImportCCMapping[]>{
    const url = '/data-import/vendor-invoice/cc-mappings-import';
    return this.http.post<InvoiceImportCCMapping[]>(url, {});
  }


  getInvoiceItemMappings():Observable<InvoiceImportItemMapping[]>{
    const url = '/data-import/vendor-invoice/item-mappings';
    return this.http.get<InvoiceImportItemMapping[]>(url);
  }
  saveInvoiceItemMappings(mappings: InvoiceImportItemMapping[]): Observable<InvoiceImportItemMapping[]> {
    const url = '/data-import/vendor-invoice/item-mappings';
    return this.http.put<InvoiceImportItemMapping[]>(url, mappings);
  }

  importInvoiceItemMappings():Observable<InvoiceImportItemMapping[]>{
    const url = '/data-import/vendor-invoice/item-mappings-import';
    return this.http.post<InvoiceImportItemMapping[]>(url, {});
  }

  addItemsToCatalog():Observable<InvoiceImportItemMapping[]>{
    const url = '/data-import/vendor-invoice/item-mappings/add-items';
    return this.http.post<InvoiceImportItemMapping[]>(url, {});
  }


}
